<template>
  <BreadCrumb :PageTitle="t('breadCrumb.level1ValidationLinks')" />
  <ValidationOneTransfertContent />
</template>

<script lang="ts">
import { defineComponent,onMounted } from "vue";
import stateStore from "../../utils/store";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ValidationOneTransfertContent from "../../components/CRM/Leads/ValidationOneTransfertContent.vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "ValidationTwoTransfertPage",
  components: {
    BreadCrumb,
    ValidationOneTransfertContent,
  },
  setup(){
    const { t } = useI18n();
    const stateStoreInstance = stateStore;
    document.body.classList.remove("sidebar-hide");
    document.body.classList.add("sidebar-show");
    onMounted(() => {
          stateStoreInstance.show = true;
        });
       return {stateStoreInstance, t};
  }
});
</script>